export default [

    {
        path: "/recruiter/mykol/list",
        name: "recruiter-mykol-list",
        meta: {
            title: "List Influencers", authRequired: true,
            subject: 'recruiter',
            action: 'read',
        },
        component: () => import("../views/recruiter/mykol/InfluencerList")
    },
    {
        path: "/recruiter/mykol/add",
        name: "recruiter-mykol-add",
        meta: {
            title: "My KOL Add", authRequired: true,
            subject: 'recruiter',
            action: 'read',
        },
        component: () => import("../views/recruiter/mykol/MyKolDetails")
    },
    {
        path: "/recruiter/mykol/edit/:id",
        name: "recruiter-mykol-edit",
        meta: {
            title: "My KOL Edit", authRequired: true,
            subject: 'recruiter',
            action: 'read',
        },
        component: () => import("../views/recruiter/mykol/MyKolDetails")
    },
    {
        path: "/recruiter/influencer/list-influencers",
        name: "recruiter-influencer-list-influencers",
        meta: {
            title: "List Influencers", authRequired: true,
            subject: 'recruiter',
            action: 'read',
        },
        component: () => import("../views/recruiter/influencer/InfluencerList")
    },
    {
        path: "/recruiter/recruitment/manage-recruitments",
        name: "recruiter-recruitment-manage-recruitments",
        meta: {
            title: "Recruitments", authRequired: true, subject: 'recruiter',
            action: 'read',
        },
        component: () => import("../views/recruiter/recruitment/RecruitmentTable")
    },
    {
        path: "/recruiter/recruitment/recruitment-details/:id",
        name: "recruiter-recruitment-recruitment-details",
        meta: {
            title: "Recruitment Details",
            authRequired: true,
            subject: 'recruiter',
            action: 'read',
        },
        component: () => import("../views/recruiter/recruitment/RecruitmentDetails"),
        props: true // Để nhận 'id' dưới dạng prop
    },
    {
        path: "/recruiter/recruitment/recruitment-details/new",
        name: "recruiter-recruitment-recruitment-create",
        meta: {
            title: "Create Recruitment",
            authRequired: true,
            subject: 'recruiter',
            action: 'write',
        },
        component: () => import("../views/recruiter/recruitment/RecruitmentDetails"), // Sử dụng chung component
    },
    {
        path: "/recruiter/recruitment/candidate/:id",
        name: "recruiter-recruitment-candidate",
        meta: {
            title: "Recruitment Candidate List", authRequired: true, subject: 'recruiter',
            action: 'read',
        },
        component: () => import("../views/recruiter/booking/BookingListInRecruitment")
    },
    {
        path: "/recruiter/recruitment/recruitment-view/:id",
        name: "recruiter-recruitment-recruitment-view",
        meta: {
            title: "Recruitment View", authRequired: true, subject: 'recruiter',
            action: 'read',
        },
        component: () => import("../views/recruiter/recruitment/RecruitmentView")
    },
    {
        path: "/recruiter/recruitment/sharing-recruitment",
        name: "recruiter-recruitment-sharing-recruitment",
        meta: {
            title: "Recruitment Sharing", authRequired: true, subject: 'recruiter',
            action: 'read',
        },
        component: () => import("../views/recruiter/recruitment/Sharing")
    },
    {
        path: "/recruiter/booking/posts-list",
        name: "recruiter-posts-list",
        meta: {
            title: "Booking Post List", authRequired: true, subject: 'recruiter',
            action: 'read',
        },
        component: () => import("../views/recruiter/booking/BookingPostList")
    },
    {
        path: "/recruiter/booking/post-create",
        name: "recruiter-posts-create",
        meta: {
            title: "Booking Post View", authRequired: true, subject: 'recruiter',
            action: 'read',
        },
        component: () => import("../views/recruiter/booking/BookingPostList")
    },
    {
        path: "/recruiter/flow/manager",
        name: "recruiter-flow-manager",
        meta: {
            title: "Flow manager", authRequired: true, subject: 'recruiter',
            action: 'read',
        },
        component: () => import("../views/recruiter/flow/FlowManager")
    },

]